import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Reviews = ({ reviews }) => (
  <section id="reviews" className="bg-sand py-24 sm:py-32 lg:py-40" data-testid="reviews-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-5 flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.3em] text-stone-500">
          <span className="h-px w-10 bg-gold" /> Guest Stories
        </p>
        <h2 className="max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          Words From <span className="italic text-gold">Our Guests</span>
        </h2>
        <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-stone-600 sm:text-base">
          From travelers who made BALIBIGVILLAS their home in Bali.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-8 md:grid-cols-3">
        {reviews.map((r, i) => (
          <Reveal key={i} delay={i * 0.12} className="h-full">
            <figure
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col border border-stone-900/10 bg-white p-8 transition-shadow duration-700 hover:shadow-[0_30px_60px_-30px_rgba(28,25,23,0.2)]"
            >
              <Quote size={22} className="text-gold" strokeWidth={1.2} />
              <div className="mt-5 flex gap-1">
                {Array.from({ length: r.rating || 5 }).map((_, s) => (
                  <Star key={s} size={13} className="fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="mt-5 flex-1 font-serif text-lg font-light italic leading-relaxed text-stone-700">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-7 border-t border-stone-900/10 pt-5">
                <p className="text-sm font-medium text-ink">{r.author}</p>
                <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-stone-500">
                  {r.country}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
